import { useEffect } from 'react';

import googleTag from 'utils/gtagEvents';

const sendLinkClick = (event: MouseEvent) => {
  let target = event.target as HTMLElement | null;

  while (target && target.tagName !== 'A') {
    target = target.parentElement;
  }

  if (target instanceof HTMLAnchorElement) {
    googleTag('link_clicks', {
      link_text: target.textContent?.trim() || '(No text)',
      link_url: target.href,
    });
  }
};

const GoogleTagLinkClicksObserver = () => {
  useEffect(() => {
    document.addEventListener('click', sendLinkClick);

    return () => document.removeEventListener('click', sendLinkClick);
  }, []);

  return <></>;
};

export default GoogleTagLinkClicksObserver;
